import React from 'react';
import { InView } from 'react-intersection-observer';

import useEventTracking from '@hooks/useEventTracking';
import { ImpressionElement, TrackingLocation, impression } from '@tracking';

import { PaywallProps } from '..';
import Content from './Content';

const PaywallBanner = ({
  buttonText,
  isPro,
  offerLink,
  paywallLeadOffers,
  title,
}: PaywallProps): JSX.Element => {
  const { Track, trackEvent } = useEventTracking({ location: TrackingLocation.Paywall });
  return (
    <aside
      className="fixed bottom-0 left-0 right-0 z-[9999]"
      id="read-this-article"
      data-testid="paywall-banner"
    >
      <Track>
        <InView
          triggerOnce={true}
          onChange={(inView) => {
            inView &&
              trackEvent(impression({ impressionElement: ImpressionElement.PaywallBanner }));
          }}
        >
          <Content
            buttonText={buttonText}
            headline={title}
            isPro={isPro}
            paywallLeadOffers={paywallLeadOffers}
            submitLink={offerLink}
          />
        </InView>
      </Track>
    </aside>
  );
};

export default PaywallBanner;
